import { API_BASE_URL } from './api-host.generated';
import { buildApiRoutes } from './api-routes';

export const environment = {
  production: false,
  apiUrl: API_BASE_URL,
  // Имя gateway-маршрута этого приложения для ?system= у /auth/web/policy и /auth/web/me
  authSystemId: 'tariff-quota',
  api: {
    ...buildApiRoutes(API_BASE_URL),
    suppliers: `${API_BASE_URL}/tariff-quota/api/suppliers`
  }
};
